module.exports = __webpack_public_path__ + "img/whale_logo.3337e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal_center/whale_logo.png
// module id = k/jR
// module chunks = 15